var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeatherWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF903C",
  d: "m12 4 10 17H2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2D2D2D",
  d: "m11.225 15.42-.39-5.65h2.342l-.39 5.65zm.78 3.103q-.529 0-.868-.334a1.07 1.07 0 0 1-.34-.79q0-.471.34-.78.34-.321.869-.321.54 0 .87.321.34.309.34.78 0 .456-.34.79-.33.334-.87.334"
})));
export default SvgWeatherWarning;